import axios from 'axios';
import { useState} from 'react'

const useDeleteWithBody = () => {
    const [loading,setLoading] = useState(false);
    const [error,setError]  = useState(null);
    const [data,setData] = useState();
    const token = localStorage.getItem('token');

    const deleteWithBody = async (url,body) => {
        setLoading(true);
        setError(null);
        try {
            const res = await axios.delete(url,{
                data: body,
                headers:{
                    'Authorization': `Bearer ${token}` 
                }
            });
            setData(res.data)
          // Handle successful deletion
        } catch (error) {
            setError(error);
          // Handle error
        } finally {
            setLoading(false);
        }
        };

    return {deleteWithBody,data,loading,error}
}

export default useDeleteWithBody
